import { StyledSelectInput } from "@aureskonnect/react-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ImCross } from "react-icons/im";
import classnames from "classnames";

import styled from "styled-components";
import { useSnapshot } from "valtio";
import { store as VerticalLayoutStore } from "@components/VerticalLayout/store";
import {
    setSelectedData,
    store,
    setRemoveSelectedData,
    clearMultiCustomSelectionData,
} from "./store";
import { toast } from "react-toastify";
import ErrorToast from "../ErrorTost";
import { useFetchGlobal } from "../../../api/hooks";

export const ValuesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;
export const Value = styled.div`
    padding: 0.3rem 0.5rem 0.3rem 0.5rem;
    margin: 5px;
    font-size: 0.75rem;
    color: black;
    background-color: hsl(0, 0%, 90%);
    user-select: none;
    border-radius: 0.3rem;
`;

export const CustomSelectInput = styled.div`
    position: relative;
`;

export const ClearButton = styled.button`
    position: absolute;
    right: 48px;
    border: none;
    top: 2px;
    height: 30px;
    cursor: pointer;
    background-color: white;
    transform: translateX(2px);
    opacity: 0.3;
    svg {
        width: 10px;
    }
`;

export const XButton = styled.button`
    all: unset;
    margin-left: 0.3rem;
    color: black;
    transition: fill 0.15s ease-in-out;
    cursor: pointer;
    &:hover {
        color: #bb392d;
    }
    &:focus {
        color: #c82f21;
    }
`;

type MultiCustomSelectType = {
    onChange: Function;
    className: any;
    placeholder: any;
    value: any;
    data: any;
    setResult: Function;
    name: string;
    result: any[];
    onDelete?: Function;
    blocked?: boolean;
    blockedList?: any;
};

export default function MultiCustomSelectV2({
    onChange,
    className,
    placeholder,
    value,
    data,
    setResult,
    name,
    result,
    onDelete,
    blocked,
    blockedList,
}: MultiCustomSelectType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { selectedData } = useSnapshot(store);
    const { franchiseID, shopID, oneShop } = useSnapshot(VerticalLayoutStore);
    const [filteredData, setFilteredData] = React.useState<any>([]);
    const shopId = oneShop ? shopID : 0;

    const handleXButton = (e: any) => {
        setRemoveSelectedData(e, name);
        if (onDelete !== undefined) {
            onDelete!();
        }
    };

    async function isModeOfSaleConsumed(element: any) {
        toast.dismiss();
        let isModeOfSaleUsed = false;

        const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${shopId}&franchiseId=${franchiseID}&type=salesMethods`;
        try {
            const result: any = await fetchGlobal(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            if (result.data.some((el: any) => el.id === element.value)) {
                isModeOfSaleUsed = true;
            }
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        return isModeOfSaleUsed;
    }

    React.useEffect(() => {
        let filteredResult: any = result.filter((el: any) => {
            return el !== "";
        });
        if (selectedData[name] === undefined) {
            filteredResult.forEach((el: any) => {
                setSelectedData(el, name);
            });
        }

        let localData = data.filter(
            (item: any) => !filteredResult.includes(item)
        );

        setFilteredData(
            localData.filter((x: any) => {
                return (
                    result
                        .map((e: any) => {
                            return e.value;
                        })
                        .indexOf(x.value) === -1
                );
            })
        );
    }, [data, result, name, selectedData]);

    React.useEffect(() => {
        setResult(selectedData[name] !== undefined ? selectedData[name] : []);
    }, [setResult, selectedData, name]);

    return (
        <React.Fragment>
            <CustomSelectInput>
                <StyledSelectInput
                    placeholder={placeholder}
                    value={value}
                    isClearable
                    className={classnames(
                        `${className}`,

                        { "not-allowed-input__clz": blocked === true }
                    )}
                    options={filteredData}
                    autocomplete="off"
                    name={name}
                    onChange={(e: any) => {
                        if (e !== null) {
                            setSelectedData(e, name);
                            onChange(e);
                        }
                    }}
                    type="text"
                    noOptionsMessage={() => t("No options")}
                    maxMenuHeight={"10vh"}
                />

                {result.length > 0 && blocked !== true ? (
                    <ClearButton
                        onClick={async (e: React.MouseEvent<HTMLElement>) => {
                            const consumedChecks = await Promise.all(
                                result.map((el: any) => isModeOfSaleConsumed(el))
                            );
                            let isConsumed = consumedChecks.some((consumed) => consumed);
                            if (!isConsumed) {
                                setResult([]);
                                clearMultiCustomSelectionData();
                            } else {
                                ErrorToast(
                                    t(
                                        "Attention! You cannot delete used sales mode."
                                    )
                                );
                            }
                        }}
                    >
                        <ImCross height={6} width={6} />
                    </ClearButton>
                ) : null}
            </CustomSelectInput>

            <div className="d-flex flex-wrap  cmn_txt_selectedBox">
                {result
                    .filter((el: any) => {
                        return el !== "";
                    })
                    .map((el: any, index: number) => {
                        return (
                            <ValuesContainer key={index}>
                                <Value
                                    key={index}
                                    className={classnames(
                                        `${className}`,

                                        {
                                            "not-allowed-input__clz":
                                                blockedList !== undefined &&
                                                blockedList.length > 0 &&
                                                blockedList.includes(el),
                                        }
                                    )}
                                >
                                    {el.label}

                                    {blockedList !== undefined &&
                                    blockedList.length > 0 &&
                                    blockedList.includes(el) ? (
                                        <span></span>
                                    ) : blocked !== true ? (
                                        <XButton
                                            className="cmn_icn_selectedBox"
                                            key={index}
                                            onClick={async (
                                                e: React.MouseEvent<HTMLElement>
                                            ) => {
                                                let isConsumed = await isModeOfSaleConsumed(
                                                    el
                                                );
                                                if (!isConsumed) {
                                                    handleXButton(el);
                                                } else {
                                                    ErrorToast(
                                                        t(
                                                            "Attention! You cannot delete used sales mode."
                                                        )
                                                    );
                                                }
                                            }}
                                        >
                                            ✕
                                        </XButton>
                                    ) : null}
                                </Value>
                            </ValuesContainer>
                        );
                    })}
            </div>
        </React.Fragment>
    );
}
